import {combineReducers} from "redux";
import NavigationReducer from "./NavigationReducer";
import messagesSlice from './messagesSlice'
import loginSlice from "../../components/Login/loginSlice";

const RootReducer = combineReducers({
    navigations: NavigationReducer,
    messages: messagesSlice,
    login: loginSlice,
});

export default RootReducer;
